import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ag-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {

  @Input()
  text?: string;

  @Input()
  title?: string;
  
  @Input()
  bodyFullWidth?: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
